module.exports = __webpack_public_path__ + "img/hk_inactive@2x.06b54150.png";